export type SkeletonVariant =
  | 'table'
  | 'cards'
  | 'chart'
  | 'detail'
  | 'gantt'
  | 'calendar'
  | 'list'
  | 'page'
  | 'sections';

export function skeletonIndexes(count: number): number[] {
  return Array.from({ length: Math.max(1, count) }, (_, i) => i);
}

/** Allow zero-length ranges (e.g. optional toolbar actions). */
export function skeletonIndexesExact(count: number): number[] {
  return Array.from({ length: Math.max(0, count) }, (_, i) => i);
}

export function skeletonColumnCount(columnLength: number | undefined): number {
  return Math.max(3, columnLength || 6);
}

/** Cycle filter pill widths so the bar looks like real search + multi-selects. */
export function skeletonFilterWidthClass(index: number, includeSearch: boolean): string {
  if (includeSearch && index === 0) return 'tt-skel--filter-search';
  const cycle = includeSearch ? (index - 1) % 3 : index % 3;
  if (cycle === 1) return 'tt-skel--filter-lg';
  return 'tt-skel--filter';
}
